import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import hash from 'object-hash'
import { SyncLedgers } from "../sync/ledgers"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetLedgers() {

    let sundryDebtorsGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-groups`))?.sundryDebtorsGrps || []

    let alterId = parseInt(window.localStorage.getItem(`tally-${TallyConfig.company}-altId`)) || 0

    let filter = sundryDebtorsGrps.map((grp) => `$Parent="${grp}"`).join(" OR ")
    filter = filter + ` OR $Parent="Sundry Debtors"`

    filter = filter + ` AND ($alterid &gt; ${alterId})`



    let data = `
    <ENVELOPE>
	<HEADER>
		<VERSION>1</VERSION>
		<TALLYREQUEST>Export</TALLYREQUEST>
		<TYPE>Collection</TYPE>
		<ID>Ledgers</ID>
	</HEADER>
	<BODY>
		<DESC>
			<STATICVARIABLES>
				<SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
				<SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
			</STATICVARIABLES>
			<TDL>
				<TDLMESSAGE>
					<COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="Ledgers">
						<TYPE>Ledger</TYPE>
						<Fetch>GUID,ALTERID,MASTERID,NAME,PARENT,ADDRESS.LIST,STATENAME,COUNTRYNAME,PINCODE,EMAIL,EMAILCC,LEDGERPHONE,LEDGERMOBILE,LEDGERCONTACT,LEDSTATENAME,GSTREGISTRATIONTYPE,VATTINNUMBER,INTERSTATESTNUMBER,EXCISEREGNO,INCOMETAXNUMBER,PARTYGSTIN,GSTDUTYHEAD,GSTDETAILS.LIST,GSTAPPROPRIATETO,TAXTYPE,GSTAPPLICABLE,APPROPRIATEFOR,GSTNATUREOFSUPPLY,GSTTYPEOFSUPPLY,RATEOFTAXCALCULATION,ISBILLWISEON,BILLCREDITPERIOD,CREDITLIMIT,PERFORMANCE,BANKDETAILS,BANKBRANCHNAME,BRANCHNAME,BANKACCHOLDERNAME,BANKBSRCODE,IFSCODE,BRANCHCODE,BANKINGCONFIGBANK,DESCRIPTION,PRICELEVEL,EXCISEALLOCTYPE,LEDMULTIADDRESSLIST.LIST,ROUNDINGMETHOD,ROUNDINGLIMIT,LEDGSTREGDETAILS.LIST,LEDMAILINGDETAILS.LIST,LEDGSTREGDETAILS.LIST,HSNDETAILS.LIST</Fetch>

                        <FILTERS>filter</FILTERS>
					</COLLECTION>

                    <SYSTEM TYPE="Formulae" NAME="filter">${filter}</SYSTEM>
				</TDLMESSAGE>
			</TDL>
		</DESC>
	</BODY>
</ENVELOPE>
    `
    data = xmlFormatter(data)
    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if(!jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER){
                return {
                    change: false,
                    status: true
                }
            }
            await SyncLedgers(jsonData)

            return {
                change: true,
                status: true
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetSalesLedgers() {

    let salesLedgersGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-groups`))?.salesLedgersGrps || []

    let data = `
    <ENVELOPE>
	<HEADER>
		<VERSION>1</VERSION>
		<TALLYREQUEST>Export</TALLYREQUEST>
		<TYPE>Collection</TYPE>
		<ID>Ledgers</ID>
	</HEADER>
	<BODY>
		<DESC>
			<STATICVARIABLES>
				<SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
				<SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
			</STATICVARIABLES>
			<TDL>
				<TDLMESSAGE>
					<COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="Ledgers">
						<TYPE>Ledger</TYPE>
						<NATIVEMETHOD>Address</NATIVEMETHOD>
						<NATIVEMETHOD>Masterid</NATIVEMETHOD>
						<NATIVEMETHOD>*</NATIVEMETHOD>

                        <FILTERS>filter</FILTERS>
					</COLLECTION>

                    <SYSTEM TYPE="Formulae" NAME="filter">${salesLedgersGrps.map((grp) => `$Parent="${grp}"`).join(" OR ")} OR $Parent="Sales Accounts"</SYSTEM>
				</TDLMESSAGE>
			</TDL>
		</DESC>
	</BODY>
</ENVELOPE>
    `
    data = xmlFormatter(data)


    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            window.localStorage.setItem(`tally-${TallyConfig.company}-sales-ledgers`, JSON.stringify(jsonData))



            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetTaxesLedgers() {

    let taxesLedgersGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-groups`))?.taxesLedgersGrps || []

    let data = `
    <ENVELOPE>
	<HEADER>
		<VERSION>1</VERSION>
		<TALLYREQUEST>Export</TALLYREQUEST>
		<TYPE>Collection</TYPE>
		<ID>Ledgers</ID>
	</HEADER>
	<BODY>
		<DESC>
			<STATICVARIABLES>
				<SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
				<SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
			</STATICVARIABLES>
			<TDL>
				<TDLMESSAGE>
					<COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="Ledgers">
						<TYPE>Ledger</TYPE>
						<NATIVEMETHOD>Address</NATIVEMETHOD>
						<NATIVEMETHOD>Masterid</NATIVEMETHOD>
						<NATIVEMETHOD>*</NATIVEMETHOD>

                        <FILTERS>filter</FILTERS>
					</COLLECTION>

                    <SYSTEM TYPE="Formulae" NAME="filter">${taxesLedgersGrps.map((grp) => `$Parent="${grp}"`).join(" OR ")} OR $Parent="Duties &amp; Taxes"</SYSTEM>
				</TDLMESSAGE>
			</TDL>
		</DESC>
	</BODY>
</ENVELOPE>
    `
    data = xmlFormatter(data)
    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            window.localStorage.setItem(`tally-${TallyConfig.company}-taxes-ledgers`, JSON.stringify(jsonData))



            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}

export async function GetBankAccounts() {

    let bankAccountsGrps = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-groups`))?.bankAccountsGrps || []

    let data = `
    <ENVELOPE>
    <HEADER>
        <VERSION>1</VERSION>
        <TALLYREQUEST>Export</TALLYREQUEST>
        <TYPE>Collection</TYPE>
        <ID>Ledgers</ID>
    </HEADER>
    <BODY>
        <DESC>
            <STATICVARIABLES>
                <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
            </STATICVARIABLES>
            <TDL>
                <TDLMESSAGE>
                    <COLLECTION ISMODIFY="No" ISFIXED="No" ISINITIALIZE="No" ISOPTION="No" ISINTERNAL="No" NAME="Ledgers">
                        <TYPE>Ledger</TYPE>
                        <NATIVEMETHOD>Address</NATIVEMETHOD>
                        <NATIVEMETHOD>Masterid</NATIVEMETHOD>
                        <NATIVEMETHOD>*</NATIVEMETHOD>

                        <FILTERS>filter</FILTERS>
                    </COLLECTION>

                    <SYSTEM TYPE="Formulae" NAME="filter">${bankAccountsGrps.map((grp) => `$Parent=${grp}`).join(" OR ")} OR $Parent="Bank Accounts"</SYSTEM>
                </TDLMESSAGE>
            </TDL>
        </DESC>
    </BODY>
</ENVELOPE>
    `
    data = xmlFormatter(data)


    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            window.localStorage.setItem(`tally-${TallyConfig.company}-bank-ledgers`, JSON.stringify(jsonData))
            return jsonData
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}